import { render, staticRenderFns } from "./BillingCustomer.vue?vue&type=template&id=65ab48c5&scoped=true"
import script from "./BillingCustomer.vue?vue&type=script&lang=js"
export * from "./BillingCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ab48c5",
  null
  
)

export default component.exports